import { useState } from "react";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLogin from "./admin/AdminLogin";

function AdminPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState("Prehled");

  if (!isLoggedIn) {
    return <AdminLogin onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <AdminDashboard
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onLogout={() => setIsLoggedIn(false)}
    />
  );
}

export default AdminPage;
